import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Use generated JSON locale files as the source of truth
import enJson from './locales/en.json';
import koJson from './locales/ko.json';
import zhCNJson from './locales/zhCN.json';
import zhTWJson from './locales/zhTW.json';
import jpJson from './locales/jp.json';
import esJson from './locales/es.json';
import ptJson from './locales/pt.json';
import viJson from './locales/vi.json';
import thJson from './locales/th.json';
import filJson from './locales/fil.json';
import idJson from './locales/id.json';
// Optional: helper to dynamically load split namespaces on demand
// Consumers can call ensureNamespaces(["trading", ...]) before using a ns
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error - JS file importing TS helper is fine in build
import { ensureNamespaces } from './loadNamespace';

i18n
  .use(LanguageDetector) // 브라우저 언어 감지기 사용
  .init({
    debug: true,
    fallbackLng: 'en',
    ns: ['common'],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false
    },
    resources: {
      // Keep existing monolithic JSONs under the "common" namespace
      ko: { common: koJson },
      en: { common: enJson },
      'zh-TW': { common: zhTWJson },
      'zh-HK': { common: zhTWJson },
      'zh-CN': { common: zhCNJson },
      jp: { common: jpJson },
      es: { common: esJson },
      pt: { common: ptJson },
      vi: { common: viJson },
      th: { common: thJson },
      fil: { common: filJson },
      tl: { common: filJson },
      id: { common: idJson },
      'id-ID': { common: idJson },
      in: { common: idJson },
      'in-ID': { common: idJson }
    },
    detection: {
      order: [
        'customDetector',
        'querystring',
        'localStorage',
        'cookie',
        'navigator',
        'htmlTag',
        'path',
        'subdomain'
      ],
      caches: ['localStorage', 'cookie']
    }
  });

// Small convenience to preload extra namespaces when needed
export async function preloadNamespaces(namespaces) {
  await ensureNamespaces(namespaces);
}

export default i18n;
